import * as React from "react";
const SvgIcCalendar = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 1H8V3H16V1H19V3H23V9V23H1V9V3H5V1ZM4 9V20H20V9H4Z" fill="currentColor" /></svg>;
export default SvgIcCalendar;